module.exports = __webpack_public_path__ + "img/logo.0edf18d8.png";